var EventBase = /** @class */ (function () {
    function EventBase(type) {
        /**
         * Type of event
         * @property type
         * @type String
         */
        this.type = undefined;
        /**
         * Reference to target object
         * @property target
         * @type Object
         */
        this.target = undefined;
        this._iAllowedToPropagate = true;
        this._iAllowedToImmediatlyPropagate = true;
        this.type = type;
    }
    /**
     * Clones the current event.
     * @return An exact duplicate of the current event.
     */
    EventBase.prototype.clone = function () {
        return new EventBase(this.type);
    };
    return EventBase;
}());
export { EventBase };
